import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../../../components/Layout/Layout';
import PageSection from '../../../components/Layout/PageSection/PageSection';
import { SnowplowPageViewTracker } from '../../../components/Analytics/Snowplow/SnowplowPageViewTracker';
import './UserTermsConditions.scss';

export default class UserTermsConditions extends React.PureComponent {
    render() {
        const { PAGE_PROPS } = this.props;
        return (
            <div className="page-TermsConditions-UserTermsConditions">
                <SnowplowPageViewTracker />
                <Layout PAGE_PROPS={PAGE_PROPS}>
                    <PageSection className="user-terms-main">
                        <h2 className="main-headline">
                            Fairygodboss Terms of Use
                        </h2>

                        <p className="effective-date">
                            <strong>Effective Date: June 23, 2023</strong>
                        </p>

                        <p>
                            PLEASE READ THIS TERMS OF USE AGREEMENT (“
                            <strong>AGREEMENT”</strong>) CAREFULLY. THIS
                            AGREEMENT IS A LEGAL CONTRACT BETWEEN YOU (“
                            <strong>USER”</strong>) AND FGB MUSE GROUP INC. (“
                            <strong>FAIRYGODBOSS</strong>,” “
                            <strong>COMPANY</strong>,” “<strong>WE</strong>,” “
                            <strong>OUR”</strong> OR “<strong>US”</strong>).
                        </p>
                        <p>
                            <strong>
                                SECTION 16 OF THIS AGREEMENT IS AN ARBITRATION
                                CLAUSE THAT REQUIRES MOST DISPUTES BETWEEN US TO
                                BE RESOLVED ON AN INDIVIDUAL, NON-CLASS ACTION
                                BASIS THROUGH BINDING AND FINAL ARBITRATION
                                INSTEAD OF IN COURT. SEE SECTION 16 FOR MORE
                                INFORMATION REGARDING THIS ARBITRATION CLAUSE,
                                AND HOW TO OPT OUT.
                            </strong>
                        </p>
                        <p>
                            By accessing or using{' '}
                            <a href="/">http://www.fairygodboss.com</a>, or any
                            other website with an authorized link to this
                            Agreement, registering an account or accessing or
                            using any content, information, services, features
                            or resources available or enabled via the website
                            (collectively, the “<strong>Services</strong>”), or
                            clicking on a button or taking another action to
                            signify your acceptance of this Agreement, you: (1)
                            agree to be bound by this Agreement and any future
                            amendments and additions to this Agreement as
                            published through the Services; (2) represent you
                            are of legal age in your jurisdiction of residence
                            to form a binding contract; and (3) represent that
                            you have the authority to enter into this Agreement
                            personally and, if applicable, on behalf of any
                            company, organization or other legal entity on whose
                            behalf you use the Services.&nbsp;
                            <strong>
                                Except as otherwise provided herein, if you do
                                not agree to be bound by this Agreement, you may
                                not access or use the Services
                            </strong>
                            .
                        </p>
                        <p>
                            Your use of the Services is also subject to any
                            additional terms, conditions and policies that we
                            separately post on the Services (“
                            <strong>Supplemental Terms</strong>”) which are
                            incorporated by reference into this Agreement. To
                            the extent there is any conflict between this
                            Agreement and the Supplemental Terms, the
                            Supplemental Terms will control with respect to the
                            subject matter of such agreement.
                        </p>
                        <p>
                            Subject to Section 16.9 of this Agreement,
                            Fairygodboss reserves the right to modify this
                            Agreement or its policies relating to the Services
                            at any time, effective upon posting of an updated
                            version of this Agreement or any applicable
                            Supplemental Terms on the applicable Services. You
                            should regularly review this Agreement, as your
                            continued use of the Services after any such changes
                            constitutes your agreement to such changes.
                        </p>
                        <ol className="terms-list">
                            <li>
                                <strong>&emsp;USE OF THE SERVICES.</strong>
                                &nbsp;&nbsp;The Services and the information and
                                content available on the Services are protected
                                by copyright laws throughout the world. Subject
                                to the Agreement, Fairygodboss grants you a
                                limited license to reproduce portions of the
                                Services for the sole purpose of using the
                                Services for your personal or internal business
                                purposes. Unless otherwise specified by
                                Fairygodboss in a separate license, your right
                                to use any and all Services is subject to the
                                Agreement.
                                <ol className="sub-list">
                                    <li>
                                        <strong>
                                            &emsp;Virtual Career Fair.
                                        </strong>
                                        &nbsp;&nbsp;In addition to the Services
                                        provided on the website, Fairygodboss
                                        may host virtual career fair events on
                                        the Services, at which Fairygodboss aims
                                        to connect recruiters at participating
                                        companies with highly qualified job
                                        seekers. For more information, or to
                                        register for the next virtual career
                                        fair, please contact us at:&nbsp;
                                        <a href="mailto:founders@fairygodboss.com">
                                            founders@fairygodboss.com
                                        </a>
                                        .
                                    </li>
                                    <li>
                                        <strong>&emsp;Privacy.</strong>
                                        &nbsp;&nbsp;Any information that you
                                        provide to Fairygodboss, as well as any
                                        information that Fairygodboss otherwise
                                        collects via the Services and your use
                                        thereof, is subject to our Privacy
                                        Policy available at&nbsp;
                                        <a href="/privacy-policy">
                                            https://fairygodboss.com/privacy-policy
                                        </a>
                                        , which governs our collection and use
                                        of such information.
                                    </li>
                                    <li>
                                        <strong>&emsp;Updates.</strong>
                                        &nbsp;&nbsp;You understand that the
                                        Services are evolving. As a result,
                                        Fairygodboss may require you to accept
                                        updates to the Services that you have
                                        installed on your computer or mobile
                                        device. You acknowledge and agree that
                                        Fairygodboss may update the Services
                                        with or without notifying you. You may
                                        need to update third-party software from
                                        time to time in order to use the
                                        Services.
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;Certain Restrictions.
                                        </strong>
                                        &nbsp;&nbsp;The rights granted to you in
                                        the Agreement are subject to the
                                        following restrictions: (a) you may not
                                        license, sell, rent, lease, transfer,
                                        assign, reproduce, distribute, host or
                                        otherwise commercially exploit the
                                        Services; (b) you may not frame or
                                        utilize framing techniques to enclose
                                        any trademark, logo, or other Services
                                        (including images, text, page layout or
                                        form) of Fairygodboss; (c) you may not
                                        use any metatags or other “hidden text”
                                        using Fairygodboss’ name or trademarks;
                                        (d) you may not modify, translate,
                                        adapt, merge, make derivative works of,
                                        disassemble, decompile, reverse compile
                                        or reverse engineer any part of Services
                                        except to the extent the foregoing
                                        restrictions are expressly prohibited by
                                        applicable law; (e) you may not use any
                                        manual or automated software, devices or
                                        other processes (including but not
                                        limited to spiders, robots, scrapers,
                                        crawlers, avatars, data mining tools or
                                        the like) to “scrape” or download data
                                        from any web pages contained in the
                                        Services (except that we grant the
                                        operators of public search engines
                                        revocable permission to use spiders to
                                        copy materials from the Services for the
                                        sole purpose of and solely to the extent
                                        necessary for creating publicly
                                        available searchable indices of the
                                        materials, but not caches or archives of
                                        such materials); (f) you may not access
                                        the Services in order to build a similar
                                        or competitive website, application or
                                        service; (g) except as expressly stated
                                        herein, no part of the Services may be
                                        copied, reproduced, distributed,
                                        republished, downloaded, displayed,
                                        posted or transmitted in any form or by
                                        any means; and (h) you may not remove or
                                        destroy any copyright notices or other
                                        proprietary markings contained on or in
                                        the Services. Any future release, update
                                        or other addition to the Services is
                                        subject to the Agreement. Fairygodboss,
                                        its suppliers and service providers
                                        reserve all rights not granted in the
                                        Agreement. Any unauthorized use of any
                                        Service terminates the licenses granted
                                        by Fairygodboss pursuant to the
                                        Agreement.
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;Third-Party Materials.
                                        </strong>
                                        &nbsp;&nbsp;As a part of the Services,
                                        you may have access to materials that
                                        are hosted by another party. You agree
                                        that it is impossible for Fairygodboss
                                        to monitor such materials and that you
                                        access these materials at your own risk.
                                    </li>
                                </ol>
                            </li>
                            <li>
                                <strong>&emsp;REGISTRATION.</strong>
                                <ol className="sub-list">
                                    <li>
                                        <strong>
                                            &emsp;Registering Your Account.
                                        </strong>
                                        &nbsp;&nbsp;In order to access certain
                                        features of the Services, you may be
                                        required to become a Registered User.
                                        For purposes of the Agreement, a “
                                        <strong>Registered User</strong>” is a
                                        User who has registered an account on
                                        the Services (“
                                        <strong>Account</strong>”) or has a
                                        valid account on the social networking
                                        service (“<strong>SNS</strong>”) through
                                        which the User has connected to the
                                        Services (each such account, a “
                                        <strong>Third-Party Account</strong>”).
                                        <ol type="a">
                                            <li>
                                                <strong>
                                                    &emsp;Community Profile.
                                                </strong>
                                                &nbsp;&nbsp;For those Users that
                                                seek to engage with other Users
                                                on the Fairygodboss community
                                                feed, such Users can create a
                                                public profile for posting or
                                                commenting on topics; reviewing
                                                employers; joining groups of
                                                other Users who share your
                                                interests, profession and
                                                lifestyle; personalizing topic,
                                                company and job preferences; and
                                                more.
                                            </li>
                                            <li>
                                                <strong>
                                                    &emsp;Job Seeker Profile.
                                                </strong>
                                                &nbsp;&nbsp;For those Users that
                                                seek to pursue employment
                                                opportunities through the
                                                Services, such Users can create
                                                a private profile for the job
                                                search (each such User, a “
                                                <strong>Job Seeker</strong>”).
                                                Job Seekers can use the Services
                                                to apply for jobs directly
                                                through the Fairygodboss
                                                messaging platform, and
                                                Fairygodboss will provide the
                                                relevant notifications to Job
                                                Seekers for any activity by
                                                employers on their applications.
                                            </li>
                                        </ol>
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;Access Through a SNS.
                                        </strong>
                                        &nbsp;&nbsp;If you access the Services
                                        through a SNS as part of the
                                        functionality of the Services, you may
                                        link your Account with Third-Party
                                        Accounts, by allowing Fairygodboss to
                                        access your Third-Party Account, as is
                                        permitted under the applicable terms and
                                        conditions that govern your use of each
                                        Third-Party Account. You represent that
                                        you are entitled to disclose your
                                        Third-Party Account login information to
                                        Fairygodboss and/or grant Fairygodboss
                                        access to your Third-Party Account
                                        (including, but not limited to, for use
                                        for the purposes described herein)
                                        without breach by you of any of the
                                        terms and conditions that govern your
                                        use of the applicable Third-Party
                                        Account and without obligating
                                        Fairygodboss to pay any fees or making
                                        Fairygodboss subject to any usage
                                        limitations imposed by such third-party
                                        service providers. By granting
                                        Fairygodboss access to any Third-Party
                                        Accounts, you understand that
                                        Fairygodboss may access, make available
                                        and store (if applicable) any
                                        information, data, text, software,
                                        music, sound, photographs, graphics,
                                        video, messages, tags and/or other
                                        materials accessible through Services
                                        (collectively, “<strong>Content</strong>
                                        ”) that you have provided to and stored
                                        in your Third-Party Account (“
                                        <strong>SNS Content</strong>”) so that
                                        it is available on and through the
                                        Services via your Account. Unless
                                        otherwise specified in the Agreement,
                                        all SNS Content is Your Content (as
                                        defined in Section 3.1) for all purposes
                                        of the Agreement. Depending on the
                                        Third-Party Accounts you choose and
                                        subject to the privacy settings that you
                                        have set in such Third-Party Accounts,
                                        personally identifiable information that
                                        you post to your Third-Party Accounts
                                        may be available on and through your
                                        Account on the Services. Please note
                                        that if a Third-Party Account or
                                        associated service becomes unavailable
                                        or Fairygodboss’ access to such
                                        Third-Party Account is terminated by the
                                        third-party service provider, then SNS
                                        Content will no longer be available on
                                        and through the Services. You have the
                                        ability to disable the connection
                                        between your Account and your
                                        Third-Party Accounts at any time by
                                        accessing the “<strong>Settings</strong>
                                        ” section of the Services. PLEASE NOTE
                                        THAT YOUR RELATIONSHIP WITH THE
                                        THIRD-PARTY SERVICE PROVIDERS ASSOCIATED
                                        WITH YOUR THIRD-PARTY ACCOUNTS IS
                                        GOVERNED SOLELY BY YOUR AGREEMENT(S)
                                        WITH SUCH THIRD-PARTY SERVICE PROVIDERS,
                                        AND FAIRYGODBOSS DISCLAIMS ANY LIABILITY
                                        FOR PERSONALLY IDENTIFIABLE INFORMATION
                                        THAT MAY BE PROVIDED TO IT BY SUCH
                                        THIRD-PARTY SERVICE PROVIDERS IN
                                        VIOLATION OF THE PRIVACY SETTINGS THAT
                                        YOU HAVE SET IN SUCH THIRD-PARTY
                                        ACCOUNTS. Fairygodboss makes no effort
                                        to review any SNS Content for any
                                        purpose, including but not limited to,
                                        for accuracy, legality or
                                        noninfringement, and Fairygodboss is not
                                        responsible for any SNS Content.
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;Registration Data.
                                        </strong>
                                        &nbsp;&nbsp;In registering an account on
                                        the Services, you agree to (a) provide
                                        true, accurate, current and complete
                                        information about yourself as prompted
                                        by the registration form (the “
                                        <strong>Registration Data</strong>”);
                                        and (b) maintain and promptly update the
                                        Registration Data to keep it true,
                                        accurate, current and complete. You
                                        represent that you are (l) at least 13
                                        years old; (m) of legal age to form a
                                        binding contract; and (n) not a person
                                        barred from using the Services under the
                                        laws of the United States, your place of
                                        residence or any other applicable
                                        jurisdiction. You are responsible for
                                        all activities that occur under your
                                        Account. You agree to monitor your
                                        Account to restrict use by minors, and
                                        you accept full responsibility for any
                                        unauthorized use of the Services by
                                        minors. You may not share your Account
                                        or password with anyone, and you agree
                                        to (y) notify Fairygodboss immediately
                                        of any unauthorized use of your password
                                        or any other breach of security; and (z)
                                        exit from your Account at the end of
                                        each session. If you provide any
                                        information that is untrue, inaccurate,
                                        not current or incomplete, or
                                        Fairygodboss has reasonable grounds to
                                        suspect that any information you provide
                                        is untrue, inaccurate, not current or
                                        incomplete, Fairygodboss has the right
                                        to suspend or terminate your Account and
                                        refuse any and all current or future use
                                        of the Services (or any portion
                                        thereof). You agree not to create an
                                        Account using a false identity or
                                        information, or on behalf of someone
                                        other than yourself. You agree not to
                                        have more than one Account per platform
                                        or SNS at any given time. Fairygodboss
                                        reserves the right to remove or reclaim
                                        any usernames at any time and for any
                                        reason, including but not limited to,
                                        claims by a third party that a username
                                        violates the third party’s rights. You
                                        agree not to create an Account or use
                                        the Services if you have been previously
                                        removed by Fairygodboss, or if you have
                                        been previously banned from any of the
                                        Services.
                                    </li>
                                    <li>
                                        <strong>&emsp;Your account.</strong>
                                        &nbsp;&nbsp;Notwithstanding anything to
                                        the contrary herein, you acknowledge and
                                        agree that you have no ownership or
                                        other property interest in your Account,
                                        and you further acknowledge and agree
                                        that all rights in and to your Account
                                        are owned by and inure to the benefit of
                                        Fairygodboss.
                                    </li>
                                </ol>
                            </li>
                            <li>
                                <strong>
                                    &emsp;RESPONSIBILITY FOR CONTENT.
                                </strong>
                                <ol className="sub-list">
                                    <li>
                                        <strong>&emsp;Types of Content.</strong>
                                        &nbsp;&nbsp;You acknowledge that all
                                        Content, the Services, is the sole
                                        responsibility of the party from whom
                                        such Content originated. This means that
                                        you, and not Fairygodboss, are entirely
                                        responsible for all Content that you
                                        upload, post, e-mail, transmit or
                                        otherwise make available (“
                                        <strong>Make Available</strong>”)
                                        through the Services (“
                                        <strong>Your Content</strong>”), and
                                        that you and other Users of the
                                        Services, and not Fairygodboss, are
                                        similarly responsible for all Content
                                        that you and they Make Available through
                                        the Services (“
                                        <strong>User Content</strong>”).
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;No Obligation to Pre-Screen
                                            Content.
                                        </strong>
                                        &nbsp;&nbsp;You acknowledge that
                                        Fairygodboss has no obligation to
                                        pre-screen Content (including, but not
                                        limited to, User Content), although
                                        Fairygodboss reserves the right in its
                                        sole discretion to pre-screen, refuse or
                                        remove any Content. By entering into the
                                        Agreement, you hereby provide your
                                        irrevocable consent to such monitoring.
                                        You acknowledge and agree that you have
                                        no expectation of privacy concerning the
                                        transmission of Your Content, including
                                        without limitation chat, text, or voice
                                        communications. In the event that
                                        Fairygodboss pre-screens, refuses or
                                        removes any Content, you acknowledge
                                        that Fairygodboss will do so for
                                        Fairygodboss’ benefit, not yours.
                                        Without limiting the foregoing,
                                        Fairygodboss has the right to remove any
                                        Content that violates the Agreement or
                                        is otherwise objectionable.
                                    </li>
                                    <li>
                                        <strong>&emsp;Storage.</strong>
                                        &nbsp;&nbsp;Unless expressly agreed to
                                        by Fairygodboss in writing elsewhere,
                                        Fairygodboss has no obligation to store
                                        any of Your Content that you Make
                                        Available on the Services. Fairygodboss
                                        has no responsibility or liability for
                                        the deletion or accuracy of any Content,
                                        including Your Content; the failure to
                                        store, transmit or receive transmission
                                        of Content; or the security, privacy,
                                        storage, or transmission of other
                                        communications originating with or
                                        involving use of the Services. Certain
                                        Services may enable you to specify the
                                        level at which such Services restrict
                                        access to Your Content. You are solely
                                        responsible for applying the appropriate
                                        level of access to Your Content. If you
                                        do not choose, the system may default to
                                        its most permissive setting. You agree
                                        that Fairygodboss retains the right to
                                        create reasonable limits on
                                        Fairygodboss’ use and storage of the
                                        Content, including Your Content, such as
                                        limits on file size, storage space,
                                        processing capacity, and similar limits
                                        described on the Services and as
                                        otherwise determined by Fairygodboss in
                                        its sole discretion.
                                    </li>
                                </ol>
                            </li>

                            <li>
                                <strong>&emsp;OWNERSHIP.</strong>
                                <ol className="sub-list">
                                    <li>
                                        <strong>&emsp;Services.</strong>
                                        &nbsp;&nbsp;Except with respect to Your
                                        Content and User Content, you agree that
                                        Fairygodboss and its suppliers own all
                                        rights, title and interest in the
                                        Services. You will not remove, alter or
                                        obscure any copyright, trademark,
                                        service mark or other proprietary rights
                                        notices incorporated in or accompanying
                                        any Services.
                                    </li>
                                    <li>
                                        <strong>&emsp;Trademarks.</strong>
                                        &nbsp;&nbsp;Fairygodboss&apos; stylized
                                        name and all related graphics, logos,
                                        service marks and trade names used on or
                                        in connection with the Services are the
                                        trademarks of Fairygodboss and may not
                                        be used without permission in connection
                                        with your or any third-party products or
                                        services. Other trademarks, service
                                        marks and trade names that may appear on
                                        or in the Services are the property of
                                        their respective owners.
                                    </li>
                                    <li>
                                        <strong>&emsp;Other Content.</strong>
                                        &nbsp;&nbsp;Except with respect to Your
                                        Content, you agree that you have no
                                        right, title, or interest in or to any
                                        Content that appears on or in the
                                        Services.
                                    </li>
                                    <li>
                                        <strong>&emsp;Your Content.</strong>
                                        &nbsp;&nbsp;Fairygodboss does not claim
                                        ownership of Your Content. However, when
                                        you as a User post or publish Your
                                        Content on or in the Services, you
                                        represent that you own and/or have a
                                        royalty-free, perpetual, irrevocable,
                                        worldwide, non-exclusive right
                                        (including any moral rights) and license
                                        to use, license, reproduce, modify,
                                        adapt, publish, translate, create
                                        derivative works from, distribute,
                                        derive revenue or other remuneration
                                        from, and communicate to the public,
                                        perform and display Your Content (in
                                        whole or in part) worldwide and/or to
                                        incorporate it in other works in any
                                        form, media or technology now known or
                                        later developed, for the full term of
                                        any worldwide intellectual property
                                        right that may exist in Your Content.
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;License to Your Content.
                                        </strong>
                                        &nbsp;&nbsp;Subject to any applicable
                                        Account settings that you select, you
                                        grant Fairygodboss a fully paid,
                                        royalty-free, perpetual, irrevocable,
                                        worldwide, royalty-free, non-exclusive
                                        and fully sublicensable right (including
                                        any moral rights) and license to use,
                                        license, distribute, reproduce, modify,
                                        adapt, publicly perform, and publicly
                                        display Your Content (in whole or in
                                        part) for the purposes of operating and
                                        providing the Services to you and to our
                                        other Users. Please remember that other
                                        Users may search for, see, use, modify
                                        and reproduce any of Your Content that
                                        you submit to any “
                                        <strong>public</strong>” area of the
                                        Services. You warrant that the holder of
                                        any worldwide intellectual property
                                        right, including moral rights, in Your
                                        Content, has completely and effectively
                                        waived all such rights and validly and
                                        irrevocably granted to you the right to
                                        grant the license stated above. You
                                        agree that you, not Fairygodboss, are
                                        responsible for all of Your Content that
                                        you Make Available on or in the
                                        Services.
                                    </li>
                                    <li>
                                        <strong>&emsp;Username.</strong>
                                        &nbsp;&nbsp;Notwithstanding anything
                                        contained herein to the contrary, by
                                        submitting Your Content to any forums,
                                        comments or any other area on the
                                        Services, you expressly permit
                                        Fairygodboss to identify you by your
                                        username (which may be a pseudonym) as
                                        the contributor of Your Content in any
                                        publication in any form, media or
                                        technology now known or later developed
                                        in connection with Your Content.
                                    </li>
                                    <li>
                                        <strong>&emsp;Your Profile.</strong>
                                        &nbsp;&nbsp;Any Content posted by you in
                                        your profile may not contain nudity,
                                        violence, sexually explicit, or
                                        offensive subject matter as determined
                                        by Fairygodboss in its sole discretion.
                                        You may not post or submit for print
                                        services a photograph of another person
                                        without that person’s permission.
                                    </li>
                                    <li>
                                        <strong>&emsp;Feedback.</strong>
                                        &nbsp;&nbsp;You agree that submission of
                                        any ideas, suggestions, documents,
                                        and/or proposals to Fairygodboss through
                                        its suggestion, feedback, wiki, forum or
                                        similar pages (“
                                        <strong>Feedback</strong>”) is at your
                                        own risk and that Fairygodboss has no
                                        obligations (including without
                                        limitation obligations of
                                        confidentiality) with respect to such
                                        Feedback. You represent and warrant that
                                        you have all rights necessary to submit
                                        the Feedback. You hereby grant to
                                        Fairygodboss a fully paid, royalty-free,
                                        perpetual, irrevocable, worldwide,
                                        non-exclusive, and fully sublicensable
                                        right and license to use, reproduce,
                                        perform, display, distribute, adapt,
                                        modify, re-format, create derivative
                                        works of, and otherwise commercially or
                                        non-commercially exploit in any manner,
                                        any and all Feedback, and to sublicense
                                        the foregoing rights, in connection with
                                        the operation and maintenance the
                                        Services and/or Fairygodboss’ business.
                                    </li>
                                </ol>
                            </li>

                            <li>
                                <strong>&emsp;USER CONDUCT.</strong>
                                &nbsp;&nbsp;As a condition of your use of the
                                Services, you may not use the Services for any
                                purpose that is prohibited by the Agreement,
                                the&nbsp;
                                <a href="/articles/community-guidelines">
                                    Community Guidelines
                                </a>{' '}
                                or by applicable law. You may not (and may not
                                permit any third party) either to (a) take any
                                action or (b) Make Available any Content on or
                                through the Services that: (i) infringes any
                                patent, trademark, trade secret, copyright,
                                right of publicity or other right of any person
                                or entity; (ii) is unlawful, threatening,
                                abusive, harassing, defamatory, libelous,
                                deceptive, fraudulent, invasive of another’s
                                privacy, tortious, obscene, offensive, or
                                profane; (iii) constitutes unauthorized or
                                unsolicited advertising, junk or bulk e-mail;
                                (iv) involves commercial activities and/or sales
                                without Fairygodboss’ prior written consent,
                                such as contests, sweepstakes, barter,
                                advertising, or pyramid schemes; (v)
                                impersonates any person or entity, including any
                                employee or representative of Fairygodboss; (vi)
                                interferes with or attempt to interfere with the
                                proper functioning of the Services or uses the
                                Services in any way not expressly permitted by
                                this Agreement; or (vii) attempts to engage in
                                or engage in, any potentially harmful acts that
                                are directed against the Services, including but
                                not limited to violating or attempting to
                                violate any security features of the Services,
                                using manual or automated software or other
                                means to access, “scrape,” “crawl” or “spider”
                                any pages contained in the Services, introducing
                                viruses, worms, or similar harmful code into the
                                Services, or interfering or attempting to
                                interfere with use of the Services by any other
                                user, host or network, including by means of
                                overloading, “flooding,” “spamming,” “mail
                                bombing,” or “crashing” the Services.
                            </li>

                            <li>
                                <strong>&emsp;INVESTIGATIONS.</strong>
                                &nbsp;&nbsp;Fairygodboss may, but is not
                                obligated to, monitor or review the Services and
                                Content at any time. Without limiting the
                                foregoing, Fairygodboss has the right, in its
                                sole discretion, to remove any of Your Content
                                for any reason (or no reason), including if such
                                Content violates the Agreement, the&nbsp;
                                <a href="/articles/community-guidelines">
                                    Community Guidelines
                                </a>{' '}
                                or any applicable law.
                            </li>

                            <li>
                                <strong>
                                    &emsp;INTERACTIONS WITH OTHER USERS.
                                </strong>
                                <ol className="sub-list">
                                    <li>
                                        <strong>
                                            &emsp;User Responsibility.
                                        </strong>
                                        &nbsp;&nbsp;You are solely responsible
                                        for your interactions with other Users
                                        and any other parties with whom you
                                        interact through the Services; provided,
                                        however, that Fairygodboss reserves the
                                        right, but has no obligation, to
                                        intercede in such disputes. You agree
                                        that Fairygodboss will not be
                                        responsible for any liability incurred
                                        as the result of such interactions.
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;Content Provided by Other
                                            Users.
                                        </strong>
                                        &nbsp;&nbsp;The Services may contain
                                        User Content provided by other Users.
                                        Fairygodboss is not responsible for and
                                        does not control User Content.
                                        Fairygodboss has no obligation to review
                                        or monitor, and does not approve,
                                        endorse or make any representations or
                                        warranties with respect to User Content.
                                        You use all User Content and interact
                                        with other Users at your own risk.
                                    </li>
                                </ol>
                            </li>

                            <li>
                                <strong>&emsp;THIRD-PARTY SERVICES.</strong>
                                &nbsp;&nbsp;The Services may contain links to
                                third-party websites (“
                                <strong>Third-Party Websites</strong>”) and
                                advertisements for third parties (“
                                <strong>Third-Party Ads</strong>”). When you
                                click on a link to a Third-Party Website or
                                Third-Party Ad, we will not warn you that you
                                have left the Services and are subject to the
                                terms and conditions (including privacy
                                policies) of another website or destination.
                                Such Third-Party Websites and Third-Party Ads
                                are not under the control of Fairygodboss.
                                Fairygodboss is not responsible for any
                                Third-Party Websites or Third-Party Ads.
                                Fairygodboss provides these Third-Party Websites
                                and Third Party Ads only as a convenience and
                                does not review, approve, monitor, endorse,
                                warrant, or make any representations with
                                respect to Third-Party Websites or Third-Party
                                Ads, or any product or service provided in
                                connection therewith. You use all links in
                                Third-Party Websites and Third-Party Ads at your
                                own risk. When you leave the Services, the
                                Agreement and policies no longer govern. You
                                should review applicable terms and policies,
                                including privacy and data gathering practices,
                                of any Third-Party Websites, and make whatever
                                investigation you feel necessary or appropriate
                                before proceeding with any transaction with any
                                third party.
                            </li>

                            <li>
                                <strong>&emsp;INDEMNIFICATION.</strong>
                                &nbsp;&nbsp;To the fullest extent permitted by
                                law, you will indemnify and hold Fairygodboss,
                                its parents, subsidiaries, affiliates, officers,
                                employees, agents, partners, suppliers, and
                                licensors (each, a “
                                <strong>Fairygodboss Party</strong>” and
                                collectively, the “
                                <strong>Fairygodboss Parties</strong>”) harmless
                                from any losses, costs, liabilities and expenses
                                (including reasonable attorneys’ fees) relating
                                to or arising out of any and all of the
                                following: (a) Your Content; (b) your use of any
                                Service in a manner not authorized by this
                                Agreement; (c) any other violation of the
                                Agreement by you; (d) your violation of any
                                rights of another party, including any Users; or
                                (e) your violation of any applicable laws, rules
                                or regulations. Fairygodboss reserves the right,
                                at its own cost, to assume the exclusive defense
                                and control of any matter otherwise subject to
                                indemnification by you, in which event you will
                                fully cooperate with Fairygodboss in asserting
                                any available defenses.
                            </li>

                            <li>
                                <strong>
                                    &emsp;DISCLAIMER OF WARRANTIES AND
                                    CONDITIONS.
                                </strong>
                                <ol className="sub-list">
                                    <li>
                                        <strong>&emsp;As Is.</strong>
                                        &nbsp;&nbsp;TO THE FULLEST EXTENT
                                        PERMITTED BY LAW, (I) YOU EXPRESSLY
                                        UNDERSTAND AND AGREE THAT YOUR USE OF
                                        THE SERVICES IS AT YOUR SOLE RISK, AND
                                        THE SERVICES ARE PROVIDED ON AN “AS IS”
                                        AND “AS AVAILABLE” BASIS, WITH ALL
                                        FAULTS AND (II) FAIRYGODBOSS PARTIES
                                        EXPRESSLY DISCLAIM ALL WARRANTIES,
                                        REPRESENTATIONS, AND CONDITIONS OF ANY
                                        KIND, WHETHER EXPRESS OR IMPLIED,
                                        INCLUDING, BUT NOT LIMITED TO, THE
                                        IMPLIED WARRANTIES OR CONDITIONS OF
                                        MERCHANTABILITY, FITNESS FOR A
                                        PARTICULAR PURPOSE AND NON-INFRINGEMENT
                                        ARISING FROM USE OF THE WEBSITE.
                                        <ol type="a">
                                            <li>
                                                &emsp;FAIRYGODBOSS PARTIES MAKE
                                                NO WARRANTY, REPRESENTATION OR
                                                CONDITION THAT: (1) THE SERVICES
                                                WILL MEET YOUR REQUIREMENTS; (2)
                                                YOUR USE OF THE SERVICES WILL BE
                                                UNINTERRUPTED, TIMELY, SECURE OR
                                                ERROR-FREE; OR (3) THE RESULTS
                                                THAT MAY BE OBTAINED FROM USE OF
                                                THE SERVICES WILL BE ACCURATE OR
                                                RELIABLE.
                                            </li>
                                            <li>
                                                &emsp;ANY CONTENT DOWNLOADED
                                                FROM OR OTHERWISE ACCESSED
                                                THROUGH THE SERVICES IS ACCESSED
                                                AT YOUR OWN RISK, AND YOU ARE
                                                SOLELY RESPONSIBLE FOR ANY
                                                DAMAGE TO YOUR PROPERTY,
                                                INCLUDING, BUT NOT LIMITED TO,
                                                YOUR COMPUTER SYSTEM AND ANY
                                                DEVICE YOU USE TO ACCESS THE
                                                SERVICES, OR ANY OTHER LOSS THAT
                                                RESULTS FROM ACCESSING SUCH
                                                CONTENT.
                                            </li>
                                            <li>
                                                &emsp;THE SERVICES MAY BE
                                                SUBJECT TO DELAYS, CANCELLATIONS
                                                AND OTHER DISRUPTIONS.
                                                FAIRYGODBOSS MAKES NO WARRANTY,
                                                REPRESENTATION OR CONDITION WITH
                                                RESPECT TO SERVICES, INCLUDING
                                                BUT NOT LIMITED TO, THE QUALITY,
                                                EFFECTIVENESS, REPUTATION AND
                                                OTHER CHARACTERISTICS OF
                                                SERVICES.
                                            </li>
                                            <li>
                                                &emsp;NO ADVICE OR INFORMATION,
                                                WHETHER ORAL OR WRITTEN,
                                                OBTAINED FROM FAIRYGODBOSS OR
                                                THROUGH THE SERVICES WILL CREATE
                                                ANY WARRANTY NOT EXPRESSLY MADE
                                                HEREIN.
                                            </li>
                                            <li>
                                                &emsp;FROM TIME TO TIME,
                                                FAIRYGODBOSS MAY OFFER NEW
                                                “BETA” FEATURES OR TOOLS WITH
                                                WHICH ITS USERS MAY EXPERIMENT.
                                                SUCH FEATURES OR TOOLS ARE
                                                OFFERED SOLELY FOR EXPERIMENTAL
                                                PURPOSES AND WITHOUT ANY
                                                WARRANTY OF ANY KIND, AND MAY BE
                                                MODIFIED OR DISCONTINUED AT
                                                FAIRYGODBOSS’S SOLE DISCRETION.
                                                THE PROVISIONS OF THIS SECTION
                                                APPLY WITH FULL FORCE TO SUCH
                                                FEATURES OR TOOLS.
                                            </li>
                                        </ol>
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;No Liability for Conduct of
                                            Third Parties.
                                        </strong>
                                        &nbsp;&nbsp;YOU ACKNOWLEDGE AND AGREE
                                        THAT FAIRYGODBOSS PARTIES ARE NOT
                                        LIABLE, AND YOU AGREE NOT TO SEEK TO
                                        HOLD FAIRYGODBOSS PARTIES LIABLE, FOR
                                        THE CONDUCT OF THIRD PARTIES, INCLUDING
                                        OPERATORS OF EXTERNAL SITES, AND THAT
                                        THE RISK OF INJURY FROM SUCH THIRD
                                        PARTIES RESTS ENTIRELY WITH YOU.
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;No Liability for Conduct of
                                            Other Users.
                                        </strong>
                                        &nbsp;&nbsp;YOU ARE SOLELY RESPONSIBLE
                                        FOR ALL OF YOUR COMMUNICATIONS AND
                                        INTERACTIONS WITH OTHER USERS OF THE
                                        SERVICES. YOU UNDERSTAND THAT
                                        FAIRYGODBOSS DOES NOT MAKE ANY ATTEMPT
                                        TO VERIFY THE STATEMENTS OF USERS OF THE
                                        SERVICES.
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;Basis of the Bargain.
                                        </strong>
                                        &nbsp;&nbsp;THE EXCLUSIONS AND
                                        LIMITATIONS OF DAMAGES SET FORTH ABOVE
                                        ARE FUNDAMENTAL ELEMENTS OF THE BASIS OF
                                        THE BARGAIN BETWEEN FAIRYGODBOSS AND YOU
                                        AND APPLY TO THE FULLEST EXTENT
                                        PERMITTED BY LAW.
                                    </li>
                                </ol>
                            </li>

                            <li>
                                <strong>&emsp;LIMITATION OF LIABILITY.</strong>
                                <ol className="sub-list">
                                    <li>
                                        <strong>
                                            &emsp;Disclaimer of Certain Damages.
                                        </strong>
                                        &nbsp;&nbsp;YOU UNDERSTAND AND AGREE
                                        THAT IN NO EVENT WILL FAIRYGODBOSS
                                        PARTIES BE LIABLE FOR ANY LOSS OF
                                        PROFITS, REVENUE OR DATA, INDIRECT,
                                        INCIDENTAL, SPECIAL, OR CONSEQUENTIAL
                                        DAMAGES, OR DAMAGES OR COSTS DUE TO LOSS
                                        OF PRODUCTION OR USE, BUSINESS
                                        INTERRUPTION, PROCUREMENT OF SUBSTITUTE
                                        GOODS OR SERVICES, IN EACH CASE WHETHER
                                        OR NOT FAIRYGODBOSS HAS BEEN ADVISED OF
                                        THE POSSIBILITY OF SUCH DAMAGES, ARISING
                                        OUT OF OR IN CONNECTION WITH THE
                                        AGREEMENT OR ANY COMMUNICATIONS,
                                        INTERACTIONS OR MEETINGS WITH OTHER
                                        USERS OF THE SERVICES, ON ANY THEORY OF
                                        LIABILITY, RESULTING FROM: (1) THE USE
                                        OR INABILITY TO USE THE SERVICES; (2)
                                        THE COST OF PROCUREMENT OF SUBSTITUTE
                                        GOODS OR SERVICES RESULTING FROM ANY
                                        GOODS, DATA, INFORMATION OR SERVICES
                                        PURCHASED OR OBTAINED OR MESSAGES
                                        RECEIVED FOR TRANSACTIONS ENTERED INTO
                                        THROUGH THE SERVICES; (3) UNAUTHORIZED
                                        ACCESS TO OR ALTERATION OF YOUR
                                        TRANSMISSIONS OR DATA; (4) STATEMENTS OR
                                        CONDUCT OF ANY THIRD PARTY ON THE
                                        SERVICES; OR (5) ANY OTHER MATTER
                                        RELATED TO THE SERVICES, WHETHER BASED
                                        ON WARRANTY, COPYRIGHT, CONTRACT, TORT
                                        (INCLUDING NEGLIGENCE), PRODUCT
                                        LIABILITY OR ANY OTHER LEGAL THEORY.
                                    </li>
                                    <li>
                                        <strong>&emsp;Cap on Liability.</strong>
                                        &nbsp;&nbsp;UNDER NO CIRCUMSTANCES WILL
                                        FAIRYGODBOSS PARTIES BE LIABLE TO YOU
                                        FOR MORE THAN THE GREATER OF (A) THE
                                        TOTAL AMOUNT PAID TO FAIRYGODBOSS BY YOU
                                        DURING THE ONE-MONTH PERIOD PRIOR TO THE
                                        ACT, OMISSION OR OCCURRENCE GIVING RISE
                                        TO SUCH LIABILITY AND (B) THE REMEDY OR
                                        PENALTY IMPOSED BY THE STATUTE UNDER
                                        WHICH SUCH CLAIM ARISES.THE FOREGOING
                                        CAP ON LIABILITY SHALL NOT APPLY TO
                                        LIABILITY OF A FAIRYGODBOSS PARTY FOR
                                        (A) DEATH OR PERSONAL INJURY CAUSED BY A
                                        FAIRYGODBOSS PARTY’S NEGLIGENCE; OR FOR
                                        (B) ANY INJURY CAUSED BY A FAIRYGODBOSS
                                        PARTY’S FRAUD OR FRAUDULENT
                                        MISREPRESENTATION.
                                    </li>
                                    <li>
                                        <strong>&emsp;User content.</strong>
                                        &nbsp;&nbsp;EXCEPT FOR FAIRYGODBOSS’
                                        OBLIGATIONS WITH RESPECT TO YOUR
                                        PERSONAL DATA AS SET FORTH IN THE
                                        FAIRYGODBOSS’ PRIVACY POLICY,
                                        FAIRYGODBOSS ASSUMES NO RESPONSIBILITY
                                        FOR THE TIMELINESS, DELETION,
                                        MIS-DELIVERY OR FAILURE TO STORE ANY
                                        CONTENT (INCLUDING, BUT NOT LIMITED TO,
                                        YOUR CONTENT AND USER CONTENT), USER
                                        COMMUNICATIONS OR PERSONALIZATION
                                        SETTINGS.
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;Basis of the Bargain.
                                        </strong>
                                        &nbsp;&nbsp;THE LIMITATIONS OF DAMAGES
                                        SET FORTH ABOVE ARE FUNDAMENTAL ELEMENTS
                                        OF THE BASIS OF THE BARGAIN BETWEEN
                                        FAIRYGODBOSS AND YOU AND APPLY, IN EACH
                                        CASE, TO THE FULLEST EXTENT PERMITTED BY
                                        LAW.
                                    </li>
                                </ol>
                            </li>

                            <li>
                                <strong>
                                    &emsp;PROCEDURE FOR MAKING CLAIMS OF
                                    COPYRIGHT INFRINGEMENT.
                                </strong>
                                &nbsp;&nbsp; It is Fairygodboss’ policy to
                                terminate membership privileges of any User who
                                repeatedly infringes copyright upon prompt
                                notification to Fairygodboss by the copyright
                                owner or the copyright owner’s legal agent.
                                Without limiting the foregoing, if you believe
                                that your work has been copied and posted on the
                                Services in a way that constitutes copyright
                                infringement, please provide our Copyright Agent
                                with the following information: (a) an
                                electronic or physical signature of the person
                                authorized to act on behalf of the owner of the
                                copyright interest; (b) a description of the
                                copyrighted work that you claim has been
                                infringed; (c) a description of the location on
                                the Services of the material that you claim is
                                infringing; (d) your address, telephone number
                                and e-mail address; (e) a written statement by
                                you that you have a good faith belief that the
                                disputed use is not authorized by the copyright
                                owner, its agent or the law; and (f) a statement
                                by you, made under penalty of perjury, that the
                                above information in your notice is accurate and
                                that you are the copyright owner or authorized
                                to act on the copyright owner’s behalf. Contact
                                information for Fairygodboss’ Copyright Agent
                                for notice of claims of copyright infringement
                                is as follows: Attn: Andrew Jurgensen, Revision
                                Legal, PLLC, 444 Cass Street, Ste. D, Traverse
                                City, MI 49684,{' '}
                                <a href="mailto:drew@revisionlegal.com">
                                    drew@revisionlegal.com
                                </a>
                            </li>

                            <li>
                                <strong>&emsp;REMEDIES.</strong>
                                <ol className="sub-list">
                                    <li>
                                        <strong>&emsp;Violations.</strong>
                                        &nbsp;&nbsp;If Fairygodboss becomes
                                        aware of any possible violations by you
                                        of the Agreement, Fairygodboss reserves
                                        the right to investigate such
                                        violations. If, as a result of the
                                        investigation, Fairygodboss believes
                                        that criminal activity has occurred,
                                        Fairygodboss reserves the right to refer
                                        the matter to, and to cooperate with,
                                        any and all applicable legal
                                        authorities. Fairygodboss is entitled,
                                        except to the extent prohibited by
                                        applicable law, to disclose any
                                        information or materials on or in the
                                        Services, including Your Content, in
                                        Fairygodboss’ possession in connection
                                        with your use of the Services, to (a)
                                        comply with applicable laws, legal
                                        process or governmental request; (b)
                                        enforce the Terms, (c) respond to any
                                        claims that Your Content violates the
                                        rights of third parties, (d) respond to
                                        your requests for customer service, or
                                        (e) protect the rights, property or
                                        personal safety of Fairygodboss, its
                                        Users or the public, and all enforcement
                                        or other government officials, as
                                        Fairygodboss in its sole discretion
                                        believes to be necessary or appropriate.
                                    </li>
                                    <li>
                                        <strong>&emsp;Breach.</strong>
                                        &nbsp;&nbsp;In the event that
                                        Fairygodboss determines, in its sole
                                        discretion, that you have breached any
                                        portion of the Agreement, or have
                                        otherwise demonstrated conduct
                                        inappropriate for the Services,
                                        Fairygodboss reserves the right to:
                                        <ol type="a">
                                            <li>
                                                &emsp;Warn you via e-mail (to
                                                any e-mail address you have
                                                provided to Fairygodboss) that
                                                you have violated the Agreement;
                                            </li>
                                            <li>
                                                &emsp;Delete any of Your Content
                                                provided by you or your agent(s)
                                                to the Services;
                                            </li>
                                            <li>
                                                &emsp;Discontinue your
                                                registration(s) with any of the
                                                Services, including any Services
                                                or any Fairygodboss community;
                                            </li>
                                            <li>
                                                &emsp;Notify and/or send Content
                                                to and/or fully cooperate with
                                                the proper law enforcement
                                                authorities for further action;
                                                and/or
                                            </li>
                                            <li>
                                                &emsp;Pursue any other action
                                                which Fairygodboss deems to be
                                                appropriate.
                                            </li>
                                        </ol>
                                    </li>
                                </ol>
                            </li>

                            <li>
                                <strong>&emsp;TERM AND TERMINATION.</strong>
                                &nbsp;&nbsp;The Agreement commences on the date
                                you accept (as described above) and remain in
                                full force and effect while you use the
                                Services, unless terminated earlier in
                                accordance with this Section. At its sole
                                discretion, Fairygodboss may modify or
                                discontinue the Services, or may modify, suspend
                                or terminate your access to the Services, for
                                any reason, with or without notice to you and
                                without liability to you or any third party. In
                                addition to suspending or terminating your
                                access to the Services, Fairygodboss reserves
                                the right to take appropriate legal action,
                                including without limitation pursuing civil,
                                criminal or injunctive redress. All provisions
                                of the Agreement which by their nature should
                                survive, will survive termination of Services,
                                including without limitation, indemnification,
                                ownership provisions, warranty disclaimers, and
                                limitation of liability.
                            </li>

                            <li>
                                <strong>&emsp;INTERNATIONAL USERS.</strong>
                                &nbsp;&nbsp;The Services can be accessed from
                                countries around the world and may contain
                                references to Services and Content that are not
                                available in your country. These references do
                                not imply that Fairygodboss intends to announce
                                such Services or Content in your country. The
                                Services are controlled and offered by
                                Fairygodboss from its facilities in the United
                                States of America. Fairygodboss makes no
                                representations that the Services are
                                appropriate or available for use in other
                                locations. Those who access or use the Services
                                from other countries do so at their own volition
                                and are responsible for compliance with local
                                law.
                            </li>

                            <li>
                                <strong>&emsp;DISPUTE RESOLUTION.</strong>
                                &nbsp;&nbsp;Please read the following
                                arbitration agreement in this Section (“
                                <strong>Arbitration Agreement</strong>”)
                                carefully. It requires you to arbitrate disputes
                                with Fairygodboss and limits the manner in which
                                you can seek relief from us.
                                <ol className="sub-list">
                                    <li>
                                        <strong>
                                            &emsp;Applicability of Arbitration
                                            Agreement.
                                        </strong>
                                        &nbsp;&nbsp;You agree that any dispute
                                        or claim relating in any way to your
                                        access or use of the Website, to any
                                        products sold or distributed through the
                                        Website, or to any aspect of your
                                        relationship with Fairygodboss, will be
                                        resolved by binding arbitration, rather
                                        than in court, except that (1) you may
                                        assert claims in small claims court if
                                        your claims qualify,; and (2) you or
                                        Fairygodboss may seek equitable relief
                                        in court for infringement or other
                                        misuse of intellectual property rights
                                        (such as trademarks, trade dress, domain
                                        names, trade secrets, copyrights, and
                                        patents).&nbsp;
                                        <strong>
                                            This Arbitration Agreement shall
                                            apply, without limitation, to all
                                            claims that arose or were asserted
                                            before the effective date of this
                                            Agreement or any prior version of
                                            this Agreement
                                        </strong>
                                        .
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;Arbitration Rules and Forum.
                                        </strong>
                                        &nbsp;&nbsp;The Federal Arbitration Act
                                        governs the interpretation and
                                        enforcement of this Arbitration
                                        Agreement. To begin an arbitration
                                        proceeding, you must send a letter
                                        requesting arbitration and describing
                                        your claim to FGB Muse Group Inc., Attn:
                                        Legal, 114 Rayson Street, 1st Floor, 
                                        Northville, MI 48167. The
                                        arbitration will be conducted by JAMS,
                                        an established alternative dispute
                                        resolution provider. Disputes involving
                                        claims and counterclaims under $250,000,
                                        not inclusive of attorneys’ fees and
                                        interest, shall be subject to JAMS’s
                                        most current version of the Streamlined
                                        Arbitration Rules and procedures
                                        available at&nbsp;
                                        <a href="https://www.jamsadr.com/rules-streamlined-arbitration">
                                            https://www.jamsadr.com/rules-streamlined-arbitration
                                        </a>
                                        ; all other claims shall be subject to
                                        JAMS’s most current version of the
                                        Comprehensive Arbitration Rules and
                                        Procedures, available at&nbsp;
                                        <a href="https://www.jamsadr.com/rules-comprehensive-arbitration">
                                            https://www.jamsadr.com/rules-comprehensive-arbitration
                                        </a>
                                        . JAMS’s rules are also available at
                                        www.jamsadr.com or by calling JAMS at
                                        800-352-5267. If JAMS is not available
                                        to arbitrate, the parties will select an
                                        alternative arbitral forum. If the
                                        arbitrator finds that you cannot afford
                                        to pay JAMS’s filing, administrative,
                                        hearing and/or other fees and cannot
                                        obtain a waiver from JAMS, Fairygodboss
                                        will pay them for you. In addition,
                                        Fairygodboss will reimburse all such
                                        JAMS’s filing, administrative, hearing
                                        and/or other fees for claims totaling
                                        less than $10,000 unless the arbitrator
                                        determines the claims are frivolous. You
                                        may choose to have the arbitration
                                        conducted by telephone, based on written
                                        submissions, or in person in the country
                                        where you live or at another mutually
                                        agreed location. Any judgment on the
                                        award rendered by the arbitrator may be
                                        entered in any court of competent
                                        jurisdiction.
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;Authority of Arbitrator.
                                        </strong>
                                        &nbsp;&nbsp;The arbitrator shall have
                                        exclusive authority to (a) determine the
                                        scope and enforceability of this
                                        Arbitration Agreement and (b) resolve
                                        any dispute related to the
                                        interpretation, applicability,
                                        enforceability or formation of this
                                        Arbitration Agreement including, but not
                                        limited to, any claim that all or any
                                        part of this Arbitration Agreement is
                                        void or voidable. The arbitration will
                                        decide the rights and liabilities, if
                                        any, of you and Fairygodboss. The
                                        arbitration proceeding will not be
                                        consolidated with any other matters or
                                        joined with any other cases or parties.
                                        The arbitrator shall have the authority
                                        to grant motions dispositive of all or
                                        part of any claim. The arbitrator shall
                                        have the authority to award monetary
                                        damages and to grant any non-monetary
                                        remedy or relief available to an
                                        individual under applicable law, the
                                        arbitral forum’s rules, and the
                                        Agreement (including the Arbitration
                                        Agreement). The arbitrator shall issue a
                                        written award and statement of decision
                                        describing the essential findings and
                                        conclusions on which the award is based,
                                        including the calculation of any damages
                                        awarded. The arbitrator has the same
                                        authority to award relief on an
                                        individual basis that a judge in a court
                                        of law would have. The award of the
                                        arbitrator is final and binding upon you
                                        and us.
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;Waiver of Jury Trial.
                                        </strong>
                                        &nbsp;&nbsp;YOU AND FAIRYGODBOSS HEREBY
                                        WAIVE ANY CONSTITUTIONAL AND STATUTORY
                                        RIGHTS TO SUE IN COURT AND HAVE A TRIAL
                                        IN FRONT OF A JUDGE OR A JURY. You and
                                        Fairygodboss are instead electing that
                                        all claims and disputes shall be
                                        resolved by arbitration under this
                                        Arbitration Agreement, except as
                                        specified in Section 16.1 above. An
                                        arbitrator can award on an individual
                                        basis the same damages and relief as a
                                        court and must follow this Agreement as
                                        a court would. However, there is no
                                        judge or jury in arbitration, and court
                                        review of an arbitration award is
                                        subject to very limited review.
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;Waiver of Class or Other
                                            Non-Individualized Relief.
                                        </strong>
                                        &nbsp;&nbsp;ALL CLAIMS AND DISPUTES
                                        WITHIN THE SCOPE OF THIS ARBITRATION
                                        AGREEMENT MUST BE ARBITRATED ON AN
                                        INDIVIDUAL BASIS AND NOT ON A CLASS OR
                                        COLLECTIVE BASIS, ONLY INDIVIDUAL RELIEF
                                        IS AVAILABLE, AND CLAIMS OF MORE THAN
                                        ONE CUSTOMER OR USER CANNOT BE
                                        ARBITRATED OR CONSOLIDATED WITH THOSE OF
                                        ANY OTHER CUSTOMER OR USERIf a decision
                                        is issued stating that applicable law
                                        precludes enforcement of any of this
                                        subsection’s limitations as to a given
                                        claim for relief, then the claim must be
                                        severed from the arbitration and brought
                                        into the State or Federal Courts located
                                        in the State of New York. All other
                                        claims shall be arbitrated.
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;30-Day Right to Opt Out.
                                        </strong>
                                        &nbsp;&nbsp;You have the right to opt
                                        out of the provisions of this
                                        Arbitration Agreement by sending written
                                        notice of your decision to opt out
                                        to&nbsp;
                                        <a href="mailto:info@fairygodboss.com">
                                            info@fairygodboss.com
                                        </a>
                                        &nbsp; within 30 days after first
                                        becoming subject to this Arbitration
                                        Agreement. Your notice must include your
                                        name and address, your Fairygodboss
                                        username (if any), the email address you
                                        used to set up your Fairygodboss Account
                                        (if you have one), and an unequivocal
                                        statement that you want to opt out of
                                        this Arbitration Agreement. If you opt
                                        out of this Arbitration Agreement, all
                                        other parts of this Agreement will
                                        continue to apply to you. Opting out of
                                        this Arbitration Agreement has no effect
                                        on any other arbitration agreements that
                                        you may currently have, or may enter in
                                        the future, with us.
                                    </li>
                                    <li>
                                        <strong>&emsp;Severability.</strong>
                                        &nbsp;&nbsp;Except as provided in
                                        Section 16.5, if any part or parts of
                                        this Arbitration Agreement are found
                                        under the law to be invalid or
                                        unenforceable, then such specific part
                                        or parts shall be of no force and effect
                                        and shall be severed and the remainder
                                        of the Arbitration Agreement shall
                                        continue in full force and effect.
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;Survival of Agreement.
                                        </strong>
                                        &nbsp;&nbsp;This Arbitration Agreement
                                        will survive the termination of your
                                        relationship with Fairygodboss.
                                    </li>
                                    <li>
                                        <strong>&emsp;Modification.</strong>
                                        &nbsp;&nbsp;Notwithstanding any
                                        provision in this Agreement to the
                                        contrary, we agree that if Fairygodboss
                                        makes any future material change to this
                                        Arbitration Agreement, you may reject
                                        that change within thirty (30) days of
                                        such change becoming effective by
                                        writing Fairygodboss at the following
                                        address: FGB Muse Group Inc., 114 Rayson
                                        Street, 1<sup>st</sup> Floor, Northville, MI 48167.
                                    </li>
                                </ol>
                            </li>

                            <li>
                                <strong>&emsp;GENERAL PROVISIONS.</strong>
                                <ol className="sub-list">
                                    <li>
                                        <strong>
                                            &emsp;Electronic Communications.
                                        </strong>
                                        &nbsp;&nbsp;The communications between
                                        you and Fairygodboss may take place via
                                        electronic means, whether you visit the
                                        Services or send Fairygodboss e-mails,
                                        or whether Fairygodboss posts notices on
                                        the Services or communicates with you
                                        via e-mail. For contractual purposes,
                                        you (a) consent to receive
                                        communications from Fairygodboss in an
                                        electronic form; and (b) agree that all
                                        terms and conditions, agreements,
                                        notices, disclosures, and other
                                        communications that Fairygodboss
                                        provides to you electronically satisfy
                                        any legal requirement that such
                                        communications would satisfy if it were
                                        to be in writing. The foregoing does not
                                        affect your statutory rights.
                                    </li>
                                    <li>
                                        <strong>&emsp;Assignment.</strong>
                                        &nbsp;&nbsp;The Agreement, and your
                                        rights and obligations hereunder, may
                                        not be assigned, subcontracted,
                                        delegated or otherwise transferred by
                                        you without Fairygodboss’ prior written
                                        consent, and any attempted assignment,
                                        subcontract, delegation, or transfer in
                                        violation of the foregoing will be null
                                        and void.
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;Questions, Complaints, Claims.
                                        </strong>
                                        &nbsp;&nbsp;If you have any questions,
                                        complaints or claims with respect to the
                                        Services, please contact us at&nbsp;
                                        <a href="mailto:info@fairygodboss.com">
                                            info@fairygodboss.com
                                        </a>
                                        . We will do our best to address your
                                        concerns. If you feel that your concerns
                                        have been addressed incompletely, we
                                        invite you to let us know for further
                                        investigation.
                                    </li>
                                    <li>
                                        <strong>&emsp;Exclusive Venue.</strong>
                                        &nbsp;&nbsp;To the extent the parties
                                        are permitted under this Agreement to
                                        initiate litigation in a court, both you
                                        and Fairygodboss agree that all claims
                                        and disputes arising out of or relating
                                        to the Agreement will be litigated
                                        exclusively in the state or federal
                                        courts located in New York, New York.
                                    </li>
                                    <li>
                                        <strong>&emsp;Governing Law.</strong>
                                        &nbsp;&nbsp;THE TERMS AND ANY ACTION
                                        RELATED THERETO WILL BE GOVERNED AND
                                        INTERPRETED BY AND UNDER THE LAWS OF THE
                                        STATE OF NEW YORK, CONSISTENT WITH THE
                                        FEDERAL ARBITRATION ACT, WITHOUT GIVING
                                        EFFECT TO ANY PRINCIPLES THAT PROVIDE
                                        FOR THE APPLICATION OF THE LAW OF
                                        ANOTHER JURISDICTION. THE UNITED NATIONS
                                        CONVENTION ON CONTRACTS FOR THE
                                        INTERNATIONAL SALE OF GOODS DOES NOT
                                        APPLY TO THE AGREEMENT.
                                    </li>
                                    <li>
                                        <strong>&emsp;Notice.</strong>
                                        &nbsp;&nbsp;Where Fairygodboss requires
                                        that you provide an e-mail address, you
                                        are responsible for providing
                                        Fairygodboss with your most current
                                        e-mail address. In the event that the
                                        last e-mail address you provided to
                                        Fairygodboss is not valid, or for any
                                        reason is not capable of delivering to
                                        you any notices required/ permitted by
                                        the Agreement, Fairygodboss’ dispatch of
                                        the e-mail containing such notice will
                                        nonetheless constitute effective notice.
                                        You may give notice to Fairygodboss at
                                        the following address: FGB Muse Group Inc.,
                                        114 Rayson Street, 1<sup>st</sup> Floor, Northville,
                                        MI 48167. Such notice shall be deemed given
                                        when received by Fairygodboss by letter
                                        delivered by nationally recognized
                                        overnight delivery service or first
                                        class postage prepaid mail at the above
                                        address.
                                    </li>
                                    <li>
                                        <strong>&emsp;Waiver.</strong>
                                        &nbsp;&nbsp;Any waiver or failure to
                                        enforce any provision of the Agreement
                                        on one occasion will not be deemed a
                                        waiver of any other provision or of such
                                        provision on any other occasion.
                                    </li>
                                    <li>
                                        <strong>&emsp;Severability.</strong>
                                        &nbsp;&nbsp;If any portion of this
                                        Agreement is held invalid or
                                        unenforceable, that portion shall be
                                        construed in a manner to reflect, as
                                        nearly as possible, the original
                                        intention of the parties, and the
                                        remaining portions shall remain in full
                                        force and effect.
                                    </li>
                                    <li>
                                        <strong>&emsp;Export Control.</strong>
                                        &nbsp;&nbsp;You may not use, export,
                                        import, or transfer the Services except
                                        as authorized by U.S. law, the laws of
                                        the jurisdiction in which you obtained
                                        the Services, and any other applicable
                                        laws. In particular, but without
                                        limitation, the Services may not be
                                        exported or re-exported (a) into any
                                        United States embargoed countries, or
                                        (b) to anyone on the U.S. Treasury
                                        Department’s list of Specially
                                        Designated Nationals or the U.S.
                                        Department of Commerce’s Denied
                                        Person&apos;s List or Entity List. By
                                        using the Services, you represent and
                                        warrant that (y) you are not located in
                                        a country that is subject to a U.S.
                                        Government embargo, or that has been
                                        designated by the U.S. Government as a
                                        “terrorist supporting” country and (z)
                                        you are not listed on any U.S.
                                        Government list of prohibited or
                                        restricted parties. You also will not
                                        use the Services for any purpose
                                        prohibited by U.S. law, including the
                                        development, design, manufacture or
                                        production of missiles, nuclear,
                                        chemical or biological weapons. You
                                        acknowledge and agree that products,
                                        services or technology provided by
                                        Fairygodboss are subject to the export
                                        control laws and regulations of the
                                        United States. You shall comply with
                                        these laws and regulations and shall
                                        not, without prior U.S. government
                                        authorization, export, re-export, or
                                        transfer Fairygodboss products, services
                                        or technology, either directly or
                                        indirectly, to any country in violation
                                        of such laws and regulations.
                                    </li>
                                    <li>
                                        <strong>
                                            &emsp;Consumer Complaints.
                                        </strong>
                                        &nbsp;&nbsp;In accordance with
                                        California Civil Code §1789.3, you may
                                        report complaints to the Complaint
                                        Assistance Unit of the Division of
                                        Consumer Services of the California
                                        Department of Consumer Affairs by
                                        contacting them in writing at 400 R
                                        Street, Sacramento, CA 95814, or by
                                        telephone at (800) 952-5210.
                                    </li>
                                    <li>
                                        <strong>&emsp;Entire Agreement.</strong>
                                        &nbsp;&nbsp;The Agreement, together with
                                        the Privacy Policy and any Supplemental
                                        Terms, is the final, complete and
                                        exclusive agreement of the parties with
                                        respect to the subject matter hereof and
                                        supersedes and merges all prior
                                        discussions between the parties with
                                        respect to such subject matter.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                        <div className="agreement-end">End of Agreement</div>
                    </PageSection>
                </Layout>
            </div>
        );
    }
}

UserTermsConditions.propTypes = {
    PAGE_PROPS: PropTypes.shape().isRequired,
};
